import { Color3, type Mesh, type Scene, StandardMaterial } from "@babylonjs/core";

export function mat(scene: Scene, name: string, r: number, g: number, b: number): StandardMaterial {
  const m = new StandardMaterial(name, scene);
  m.diffuseColor = new Color3(r, g, b);
  m.specularColor = Color3.Black();
  return m;
}

export function solid(mesh: Mesh, m: StandardMaterial, pickable = false): Mesh {
  mesh.material = m;
  mesh.checkCollisions = true;
  mesh.isPickable = pickable;
  return mesh;
}
